@let vm = controller.viewModel();
@let minimized = controller.minimized();

<ng-container
  [ngTemplateOutlet]="navItemTemplate"
  [ngTemplateOutletContext]="{ $implicit: vm.children, group: undefined }"
/>

<ng-template
  #navItemTemplate
  [ngTemplateType]="NavItemTemplateItemsContext"
  let-items
  let-group="group"
>
  @for (item of items; track item.label) {
    @switch (item.type) {
      @case ('section') {
        <ng-container
          [ngTemplateOutlet]="navSectionTemplate"
          [ngTemplateOutletContext]="{ $implicit: item }"
        />
      }
      @case ('link') {
        <ng-container
          [ngTemplateOutlet]="navLinkTemplate"
          [ngTemplateOutletContext]="{ $implicit: item, group: group }"
        />
      }
      @case ('group') {
        <ng-container
          [ngTemplateOutlet]="navGroupTemplate"
          [ngTemplateOutletContext]="{ $implicit: item, group: group }"
        />
      }
      @case ('separator') {
        <ng-container
          [ngTemplateOutlet]="navSeparatorTemplate"
          [ngTemplateOutletContext]="{ $implicit: item, group: group }"
        />
      }
    }
  }
</ng-template>

<ng-template
  #navLinkTemplate
  [ngTemplateType]="NavItemTemplateLinkContext"
  let-item
  let-group="group"
>
  <tlc-navigation-link
    [href]="item | navigationItemPath"
    [testId]="item.testId"
    [walkthroughId]="item.walkthroughId"
    [minimized]="minimized"
    [label]="item.label"
    [icon]="item.icon"
    [iconSvg]="item.iconSvg"
    [badges]="item.badges ?? []"
    [isActive]="item.isActive ?? false"
    [isChild]="item.isChild ?? false"
    [isExpanded]="item.isExpanded ?? false"
    [upgrade]="item.upgrade"
    (click)="onNavigationLinkClick(item, group)"
  />
</ng-template>

<ng-template #navSectionTemplate [ngTemplateType]="NavItemTemplateSectionContext" let-item>
  @if (vm.hasMultipleSections) {
    <tlc-navigation-separator [label]="item.label" [minimized]="minimized" />
  }

  <ng-container
    [ngTemplateOutlet]="navItemTemplate"
    [ngTemplateOutletContext]="{ $implicit: item.children }"
  />
</ng-template>

<ng-template #navGroupTemplate [ngTemplateType]="NavItemTemplateGroupContext" let-item>
  @let firstLinkInGroup = findFirstLink(item.children);

  @if (firstLinkInGroup) {
    <tlc-navigation-group
      [testId]="firstLinkInGroup.testId"
      [walkthroughId]="firstLinkInGroup.walkthroughId"
      [href]="item | navigationItemPath"
      [minimized]="minimized"
      [label]="item.label"
      [icon]="item.icon"
      [badges]="item.badges ?? []"
      [isActive]="item.isActive ?? false"
      [isChild]="item.isChild ?? false"
      [isExpanded]="item.isExpanded ?? false"
      (toggle)="minimized ? onNavigationLinkClick(firstLinkInGroup) : onNavigationGroupClick(item)"
    >
      @if (!minimized && item.isExpanded) {
        <ng-container
          [ngTemplateOutlet]="navItemTemplate"
          [ngTemplateOutletContext]="{ $implicit: item.children, group: item }"
        />
      }
    </tlc-navigation-group>
  }
</ng-template>

<ng-template #navSeparatorTemplate [ngTemplateType]="NavItemTemplateSeparatorContext" let-item>
  <tlc-navigation-separator
    [label]="item.label"
    [nested]="item.isChild === true"
    [minimized]="minimized"
  />
</ng-template>
